import { __assign } from "tslib";
import { partial } from 'lodash';
import { connect } from 'react-redux';
import * as actionCreators from '../actionCreators';
import HoverOutLayer from '../components/HoverOutLayer';
import { getNumberOfHoverOutLevels } from '../utils/hover';
import { getEventMeta } from '../utils/userTest';
var mapStateToProps = function (state) { return ({
    hoverStack: state.hoverStack,
    getEventMeta: partial(getEventMeta, state),
}); };
function mergeProps(stateProps, _a, ownProps) {
    var dispatch = _a.dispatch;
    var hoverStack = stateProps.hoverStack;
    return __assign(__assign(__assign({}, stateProps), ownProps), { onMouseMove: function (event) {
            var scrollPos = ownProps.getScreenScrollPos();
            var numberOfLevels = getNumberOfHoverOutLevels(event, hoverStack, scrollPos);
            if (numberOfLevels > 0) {
                dispatch(actionCreators.hoverOut(numberOfLevels, scrollPos, stateProps.getEventMeta(event)));
            }
        } });
}
export default connect(mapStateToProps, null, mergeProps)(HoverOutLayer);
